import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { ArrowUpIcon } from '~/assets/icons'
import classNames from 'classnames/bind'

import styles from './index.module.scss'
const cx = classNames.bind(styles)

// Nút hiển thị icon arrow không đuôi. Dùng để bấm vào cuộn lên trên đầu trang
const ScrollTop = () => {
  const [showButton, setShowButton] = useState(false)

  const handleClickScrollTop = () => {
    window.scroll(0, 0)
  }

  useEffect(() => {
    // Cuộn xuống được khoảng 20px thì hiển thị
    const handleScroll = () => {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    // Huỷ bỏ sự kiện
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Button className={cx('wrapper', { showButton })} onClick={handleClickScrollTop}>
      <ArrowUpIcon />
    </Button>
  )
}

export default React.memo(ScrollTop)
